import { motion } from 'framer-motion';
import { AnimationVariations } from '..';

interface Props {
  variant: AnimationVariations;
}

const CapabilitiesPieces = (props: Props) => {
  const { variant } = props;

  const variants = {
    default: {
      pathLength: 0,
      transition: {
        duration: 2,
      },
    },
    show: {
      pathLength: 1,
      transition: {
        duration: 2,
      },
    },
  };

  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 599.2 508"
      xmlSpace="preserve"
    >
      <motion.path
        variants={variants}
        animate={variant}
        id="Combined-Shape_00000160152179724775717510000013007301791533092501_"
        fill="none"
        stroke="#B1D2F3"
        strokeDasharray="149.3145,149.3145"
        d="M297.1,5.2l26.2,33
	c0.1,0.2,0.3,0.3,0.4,0.5c0.1,0.1,0.1,0.2,0.2,0.3c0.2,0.3,0.4,0.7,0.6,1.1l0,0l0.2,0.3c0,0.1,0.1,0.2,0.1,0.2
	c0.2,0.4,0.3,0.7,0.5,1.1c0.1,0.2,0.1,0.4,0.2,0.5c0.2,0.6,0.3,1.2,0.4,1.8l0,0l2.8,17.1l-4.5,9.3l-18.6-23.4"
      />
      <motion.path
        variants={variants}
        animate={variant}
        id="Combined-Shape-2_00000029748339229907874200000004403383283437275323_"
        fill="none"
        stroke="#B1D2F3"
        strokeDasharray="379.8768,379.8768"
        d="M324.3,70.5l-51.8,107.4l0,0
	l7.4,9.3l-9.1,18.7l-14.2,2.9l-18.3-23"
      />
      <motion.path
        variants={variants}
        animate={variant}
        id="Fill-10_00000182507196331261012530000010829662246002061713_"
        fill="none"
        stroke="#B1D2F3"
        strokeDasharray="229.7969,229.7969"
        d="M46.6,348.2l26.2,32.9c3,3.7,8,5.5,13.4,4.2
	l56.4-13l-26.2-32.9"
      />
      <motion.path
        variants={variants}
        animate={variant}
        id="Combined-Shape-3_00000072278209043564255920000007516737489920992164_"
        fill="none"
        stroke="#B1D2F3"
        strokeDasharray="374.2592,374.2592"
        d="M427.2,251.2
	c-25.8-24.3-60.1-39.3-97.5-41.5c-11.8-3.4-23.9-5.2-36.2-5.4l-21-26.5"
      />
      <motion.path
        variants={variants}
        animate={variant}
        id="Fill-18_00000033336043589199140190000006155267177575159708_"
        fill="none"
        stroke="#B1D2F3"
        strokeDasharray="352.899,352.899"
        d="M572.5,254.7l26.2,32.9l-130.9,30.2
	l-26.2-32.9"
      />
      <motion.path
        variants={variants}
        animate={variant}
        id="square"
        fill="none"
        stroke="#B1D2F3"
        strokeDasharray="1065.4756,1065.4756"
        d="M238.2,185.8c-68.5,23-116.8,85.5-121.7,153.6l-56.4,13c-7.8,1.8-14.8-2.6-16-10.2L0.7,80.1
	c-1.3-7.6,3.8-14.8,11.6-16.6L283.7,0.9c7.8-1.8,14.8,2.6,16,10.2l6,36L241,180.4L238.2,185.8z"
      />
      <motion.path
        variants={variants}
        animate={variant}
        id="triangle"
        fill="none"
        stroke="#B1D2F3"
        strokeDasharray="823.7543,823.7543"
        d="M456.2,147l116.3,107.7l-130.9,30.2c-20.6-71.9-91.6-117-169.1-107l66.9-138.5L456.2,147z"
      />
      <motion.path
        variants={variants}
        animate={variant}
        id="circle_bottom"
        fill="none"
        stroke="#B1D2F3"
        strokeDasharray="940.9656,940.9656"
        d="M170.2,427.2l26.2,33c29.7,37.3,80.4,55.7,133.2,43.5c2.1-0.5,4.1-1,6.2-1.6
	c0.5-0.1,1-0.3,1.6-0.4c1.9-0.6,3.9-1.1,5.8-1.8c0.1,0,0.2-0.1,0.3-0.1c2-0.7,4-1.4,5.9-2.1c0.5-0.2,1-0.4,1.5-0.6
	c1.8-0.7,3.5-1.4,5.3-2.2l0.6-0.2c1.9-0.8,3.7-1.7,5.6-2.6c0.5-0.2,0.9-0.5,1.4-0.7c0.6-0.3,1.1-0.6,1.7-0.8c0.9-0.5,1.8-1,2.6-1.4
	c0.5-0.3,1-0.5,1.5-0.8c1.8-1,3.6-2.1,5.4-3.2c0.3-0.2,0.6-0.4,0.9-0.6c1.5-0.9,2.9-1.9,4.3-2.8c0.6-0.4,1.1-0.8,1.6-1.1
	s1.1-0.8,1.7-1.2c0.4-0.3,0.7-0.6,1.1-0.9c1.6-1.1,3.1-2.3,4.6-3.5c0.6-0.5,1.2-1,1.8-1.5c2.1-1.7,4.1-3.4,6-5.2c0,0,0.1,0,0.1-0.1
	c0.2-0.2,0.5-0.4,0.7-0.7c1.6-1.5,3.1-2.9,4.6-4.5c0.6-0.6,1.2-1.2,1.8-1.8c1.2-1.2,2.3-2.4,3.4-3.6c0.3-0.3,0.5-0.6,0.8-0.9
	c0.4-0.4,0.7-0.9,1.1-1.3c1-1.1,2-2.3,2.9-3.5c0.6-0.7,1.2-1.5,1.8-2.3c1-1.2,1.9-2.5,2.8-3.7c0.4-0.5,0.8-1,1.1-1.5
	c0.2-0.2,0.3-0.5,0.5-0.7c1.1-1.6,2.2-3.2,3.3-4.8c0.3-0.5,0.6-0.9,0.9-1.4c1.3-2.1,2.6-4.2,3.8-6.4c0.1-0.1,0.1-0.2,0.2-0.3
	c0.2-0.4,0.4-0.8,0.6-1.2c1-1.8,2-3.6,2.9-5.5c0.4-0.8,0.7-1.5,1.1-2.3c0.8-1.7,1.6-3.3,2.3-5c0.2-0.5,0.5-1,0.7-1.4
	c0.2-0.4,0.3-0.8,0.5-1.2c0.2-0.6,0.5-1.2,0.7-1.8c0.5-1.4,1-2.7,1.5-4.1l0,0c0.2-0.6,0.4-1.1,0.6-1.7c0.7-1.9,1.3-3.8,1.9-5.8
	c0-0.1,0-0.1,0-0.2c0.5-1.6,0.9-3.2,1.3-4.8c0.1-0.3,0.1-0.6,0.2-0.9c0.1-0.6,0.3-1.1,0.4-1.7c0.3-1.5,0.7-2.9,1-4.4
	c0.1-0.6,0.2-1.1,0.3-1.7c0.4-2,0.7-3.9,1-5.9c0-0.1,0-0.2,0-0.3c0.3-1.9,0.5-3.8,0.7-5.7c0.1-0.6,0.1-1.2,0.2-1.8
	c0.1-1.5,0.2-3,0.3-4.6c0-0.6,0.1-1.1,0.1-1.7c0.1-2,0.1-4,0.1-6c0-0.3,0-0.6,0-0.8c0-1.3,0-2.7-0.1-4c0-0.3-0.1-0.7-0.1-1
	c-0.1-1.4-0.2-2.9-0.3-4.3c-0.1-1-0.1-1.9-0.2-2.9c-0.2-1.6-0.4-3.1-0.6-4.7c-0.1-0.7-0.2-1.4-0.3-2.1c0-0.3-0.1-0.5-0.1-0.8
	c-0.4-2.5-0.9-4.9-1.4-7.3c-0.1-0.4-0.2-0.7-0.2-1.1c-0.5-2.3-1.1-4.5-1.8-6.7c-0.1-0.4-0.2-0.8-0.4-1.3c-0.7-2.2-1.4-4.4-2.2-6.5
	c-0.1-0.3-0.2-0.6-0.3-0.9c-0.8-2.1-1.7-4.3-2.6-6.3c-0.1-0.1-0.1-0.2-0.2-0.4c-0.6-1.4-1.3-2.8-2-4.2c-0.3-0.6-0.7-1.3-1-1.9
	c-0.2-0.4-0.5-0.9-0.7-1.3c-1-2-2.1-3.9-3.3-5.8c-0.2-0.3-0.4-0.6-0.6-0.9c-1-1.7-2.1-3.4-3.3-5c-0.2-0.4-0.5-0.7-0.7-1.1
	c-0.2-0.2-0.3-0.4-0.4-0.7c-1.2-1.7-2.5-3.4-3.8-5l-26.2-32.9"
      />
      <motion.path
        variants={variants}
        animate={variant}
        id="circle"
        fill="none"
        stroke="#B1D2F3"
        strokeDasharray="856.8237,856.8237"
        d="M259.3,208.1c75-17.3,146,27.2,158,99.9c12,72.7-38.9,145.4-114,162.7s-146-27.2-158-99.9
	C133.3,298.1,184.3,225.4,259.3,208.1"
      />
    </svg>
  );
};

export default CapabilitiesPieces;
